import { Navigate } from "react-router-dom";

const oldToNewRouteMapping = (shipmentId: string) => ({
  [`/shipment/tracking/${shipmentId}`]: `/shipment/${shipmentId}/tracking`,
  [`/shipment/quick/tracking/${shipmentId}`]: `/shipment/${shipmentId}/quick/tracking`,
  [`/shipment/detail/${shipmentId}`]: `/shipment/${shipmentId}/detail`,
  [`/shipment/quick/detail/${shipmentId}`]: `/shipment/${shipmentId}/quick/detail`,
  [`/shipment/billing/${shipmentId}`]: `/shipment/${shipmentId}/billing`,
  [`/shipment/audit-trail/${shipmentId}`]: `/shipment/${shipmentId}/audit-trail`,
  [`/shipment/quick/audit-trail/${shipmentId}`]: `/shipment/${shipmentId}/quick/audit-trail`,
  [`/shipment/quick/${shipmentId}`]: `/shipment/${shipmentId}/quick`,
});
const shipmentIdRegex = /(S|QR)\d+/g;

function ShipmentRouteRedirection() {
  let url = document.location.pathname;
  if (url.at(-1) === "/") {
    url = url.slice(0, url.length - 1);
  }
  const urlArray = url.split("/");
  const shipmentIdUrl = urlArray.at(-1);
  const newRoute = oldToNewRouteMapping(shipmentIdUrl!)?.[url];

  if (!shipmentIdRegex.test(shipmentIdUrl!) || !newRoute) {
    return null;
  }
  return <Navigate to={newRoute} replace />;
}

export default ShipmentRouteRedirection;
